export default "__VITE_ASSET__C3Goi0dX__"